import React from 'react';

const NavbarBrand = () => {
  return (
    <div 
      className="navbar-brand-container d-flex align-items-center" 
      style={{ display: 'flex', alignItems: 'center', marginTop: '-18px' }}
    >
      <img
        src="/Assests/Logo.png"
        alt="Logo"
        className="me-2 logo"
        style={{
          width: '130px',
          height: 'auto',
          maxWidth: '100%',
          marginTop: '-40px',
        }}
      />
      <div className="navbar-title" style={{ display: 'flex', flexDirection: 'column' }}>
        <div 
          className="title-text"
          style={{
            fontSize: '1.65rem',
            fontWeight: 'bold',
            color: 'white',
            marginTop: '-34px'
          }}
        >
          Sri Takshashila
        </div>
        <div 
          className="title-text"
          style={{
            fontSize: '3.1rem',
            fontWeight: 'bold',
            color: 'darkblue',
            marginTop: '-15px'
          }}
        >
          Gurukul
        </div>
      </div>

      {/* Mobile-specific styling using media queries */}
      <style jsx>{`
        @media (max-width: 768px) {
          .navbar-brand-container {
            margin-top: 5px !important;
            margin-left: -10px !important; /* Move left */
          }

          .logo {
            width: 80px !important; /* Decrease size */
            margin-top: 5px !important; /* Move down */
          }

          .navbar-title {
            flex-direction: column !important;
            align-items: flex-start !important;
            margin-left: 5px !important;
          }

          .title-text {
            font-size: 1rem !important;
            margin-top: 0 !important;
            color: darkblue !important; /* Ensure consistency */
          }
        }
      `}</style>
    </div>
  );
};

export default NavbarBrand;
